import React from 'react';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';

const Locked = () => {

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { locked },
  } = localizedStrings;

  return (
    <>
      <Button disabled >{locked}</Button>
    </>
  );
};

export default Locked;
